import { render, staticRenderFns } from "./FlightLegItem.vue?vue&type=template&id=3aea29e4&scoped=true&"
import script from "./FlightLegItem.vue?vue&type=script&lang=js&"
export * from "./FlightLegItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightLegItem.vue?vue&type=style&index=0&id=3aea29e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea29e4",
  null
  
)

export default component.exports